import React from "react";
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import {WizTableForm} from "../../../common";

let {WizPopover, WizButton, WizDataTable} = component_tool
const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})

export default (self, type, info) => {
  let columns = []
  if (type.indexOf('comment') !== -1) {
    columns = columns.concat([
      {
        title: '账号',
        name: 'userName',
        searchItem: {},
      },
      {
        title: '姓名',
        name: 'fullName',
        searchItem: {},
      },
      {
        title: '岗位',
        name: 'positionId',
        searchItem: {
          ...positionConfig,
          diy: WizTableForm,
          selectType: 'radio',
        },
      },
      {
        title: '组织',
        name: 'orgId',
        searchItem: {
          ...organizationConfig,
          diy: WizTableForm,
          selectType: 'radio',
        }
      },
      {
        title: "评论内容",
        name: "content",
        tableItem: {}
      },
      {
        title: '姓名',
        name: 'commentFullName',
        tableItem: {}
      },
      {
        title: '账号',
        name: 'commentUserName',
        tableItem: {}
      },
      {
        title: '任职',
        name: 'userIdentityInfos',
        tableItem: {
          render: (text, record) => {
            let contextList = text && text.split(',').length ? text.split(',') : []
            let content = [];
            let title = ''
            contextList && contextList.length && contextList.map((d, index) => {
              if (index === 0) {
                title = d
              }
              content.push(<p key={'p_' + index}>{d}</p>)
            })
            let _titleView = []
            _titleView.push(title)
            if (contextList && contextList.length > 1) {
              _titleView.push(<span className='wiz-press-font-color'> ...</span>)
            }
            return (
              <WizPopover content={content} placement="rightTop">
                {_titleView}
              </WizPopover>
            )
          }
        }
      },
      {
        title: '评论时间',
        name: 'commentTime',
        tableItem: {},
      },
      {
        title: "是否屏蔽",
        name: "switchScreen",
        tableItem: {},
        dict: [
          { code: 0, codeName: "否" },
          { code: 1, codeName: "是" },
        ],
      },
      {
        title: "被回复的评论人",
        name: "replyFullName",
        tableItem: {}
      },
      {
        title: "点赞数",
        name: "agreeNum",
        tableItem: {}
      },
      {
        title: "操作",
        tableItem: {
          render: (text, record) => {
            let btn = record.switchScreen === 0 ? "屏蔽" : "取消屏蔽";
            let apiParams = {
              id: record.id,
              state: record.status === 0 ? 1 : 0,
            };
            return (
              <WizDataTable.Oper>
                <WizButton
                  onClick={() => self._onChangeScreen(apiParams, record.state)}
                >
                  {btn}
                </WizButton>
              </WizDataTable.Oper>
            );
          },
        },
      },
    ])
  }
  if (type.indexOf('comment') === -1) {
    columns = columns.concat([
      {
        title: '账号',
        name: 'userName',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '姓名',
        name: 'fullName',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '岗位',
        name: 'positionId',
        searchItem: {
          ...positionConfig,
          diy: WizTableForm,
          selectType: 'radio',
        },
      },
      {
        title: '组织',
        name: 'orgId',
        searchItem: {
          ...organizationConfig,
          diy: WizTableForm,
          selectType: 'radio',
        }
      },
      {
        title: '任职',
        name: 'userIdentityInfos',
        tableItem: {
          render: (text, record) => {
            let contextList = text && text.split(',').length ? text.split(',') : []
            let content = [];
            let title = ''
            contextList && contextList.length && contextList.map((d, index) => {
              if (index === 0) {
                title = d
              }
              content.push(<p key={'p_' + index}>{d}</p>)
            })
            let _titleView = []
            _titleView.push(title)
            if (contextList && contextList.length > 1) {
              _titleView.push(<span className='wiz-press-font-color'> ...</span>)
            }
            return (
              <WizPopover content={content} placement="rightTop">
                {_titleView}
              </WizPopover>
            )
          }
        }
      }
    ])
  }
  if (type.indexOf('agree') !== -1) {
    columns = columns.concat([
      {
        title: '点赞时间',
        name: 'operateTime',
        tableItem: {}
      },
    ])
  }
  if (type.indexOf('look') !== -1) {
    columns = columns.concat([
      {
        title: '观看时间',
        name: 'operateTime',
        tableItem: {}
      }
    ])
  }
  if (type.indexOf('share') !== -1) {
    columns = columns.concat([
      {
        title: '分享时间',
        name: 'operateTime',
        tableItem: {}
      },
      {
        title: '分享平台',
        name: 'sharePlatform',
        tableItem: {
          render: (text, record) => {
            let val = text;
            if (text === 'wechat') {
              val = '微信'
            }
            return val;
          },
        }
      }
    ])
  }
  if (type.indexOf('collect') !== -1) {
    columns = columns.concat([
      {
        title: '收藏时间',
        name: 'operateTime',
        tableItem: {}
      },
    ])
  }
  return columns
}
